<template>
  <div style="overflow: hidden; padding: 8px">
    <vs-row>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        نوع تخفیف:
        <vs-select v-model="couponType" width="100%" class="w-100 mt-1">
          <vs-select-item
            v-for="(couponType, index) in ['percentage', 'amount']"
            :value="couponType"
            :text="`${couponType === 'percentage' ? 'درصدی' : 'مقداری'}`"
            :key="index"
            icon="arrow_downward"
          />
        </vs-select>
      </vs-col>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        مقدار تخفیف:
        <vs-input
          v-model="couponValue"
          :placeholder="`${
            couponType === 'percentage'
              ? 'درصد تخفیف را وارد کنید'
              : 'مقدار تخفیف را وارد کنید'
          }`"
          class="w-100 mt-1"
        />
      </vs-col>

      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        نام تخفیف: (کد تخفیفی که توسط مشتری وارد میشود.)
        <vs-input
          v-model="couponName"
          placeholder="نام کد تخفیف را وارد کنید"
          class="w-100 mt-1"
        />
      </vs-col>

      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        <p class="mb-1">تاریخ انقضا:</p>
        <date-picker
          v-model="expireDate"
          format="YYYY-MM-DD"
          display-format="jYYYY-jMM-jDD"
          auto-submit
        />
      </vs-col>

      <vs-col vs-w="6">
        <vs-checkbox v-model="unlimited" :value="unlimited"
          >استفاده دائمی و نامحدود برای کاربران</vs-checkbox
        >
      </vs-col>

      <vs-col vs-justify="center" vs-align="center" vs-w="12">
        <div class="flex justify-end">
          <vs-button @click="confirm">{{
            couponId ? "ویرایش" : "ایجاد"
          }}</vs-button>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "NewCoupon.vue",
  data() {
    return {
      couponName: null,
      couponValue: null,
      couponType: "percentage",
      expireDate: null,
      couponId: null,
      unlimited: false,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  watch: {
    coupon(coupon) {
      this.initialCouponValues(coupon);
    },
  },
  mounted() {
    if (this.coupon) {
      this.initialCouponValues(this.coupon);
    }
  },
  methods: {
    initialCouponValues(coupon) {
      this.couponName = coupon.code;
      this.couponValue = coupon.value;
      this.couponType = coupon.percentage_based ? "percentage" : "amount";
      this.expireDate = coupon.expires_at;
      this.couponId = coupon.id;
      this.unlimited = coupon.unlimited;
    },
    resetValues() {
      this.couponName = null;
      this.couponValue = null;
      this.expireDate = null;
      this.couponId = null;
      this.couponType = "percentage";
      this.unlimited = false;
    },
    confirm() {
      if (!this.validateInputs()) return;

      this.$vs.loading();
      providerApiService
        .createOrEditCoupon(
          this.currentProvider.id,
          {
            code: this.couponName,
            value: this.couponValue,
            percentage_based: this.couponType === "percentage" ? 1 : 0,
            expires_at: this.expireDate,
            unlimited: this.unlimited,
          },
          this.couponId
        )
        .then((result) => {
          if (this.couponId) {
            /**
             * Update
             */
            this.$emit("couponEdited", result.resource);
          } else {
            /**
             * Create
             */
            this.$vs.notify({
              text: "کد تخفیف با موفقیت ایجاد شد.",
              color: "success",
              position: "bottom-center",
            });
            this.$emit("couponCreated", result.resource);
            this.resetValues();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.error.response
              ? e.error.response.data.message
              : "عملیات با خطا مواجه شد",
            color: "danger",
            position: "bottom-center",
          });
        })
        .finally(() => this.$vs.loading.close());
    },
    validateInputs() {
      if (!this.couponValue) {
        this.$vs.notify({
          text: "مقدار تخفیف اجباریست.",
          color: "warning",
          position: "bottom-center",
        });
        return false;
      }

      if (!this.couponName) {
        this.$vs.notify({
          text: "نام تخفیف اجباریست.",
          color: "warning",
          position: "bottom-center",
        });
        return false;
      }

      if (!this.expireDate) {
        this.$vs.notify({
          text: "تاریخ انقضا اجباریست.",
          color: "warning",
          position: "bottom-center",
        });
        return false;
      }

      return true;
    },
  },
  props: {
    coupon: {
      required: false,
      type: Object,
    },
  },
};
</script>
